export const GET_TRACKER_STATISTICS = "GET_TRACKER_STATISTICS";
export const SAVE_TRACKER_STATISTICS = "SAVE_TRACKER_STATISTICS";
